import { render } from "./SendNft.vue?vue&type=template&id=80680cb8"
import script from "./SendNft.vue?vue&type=script&lang=ts"
export * from "./SendNft.vue?vue&type=script&lang=ts"

import "./SendNft.vue?vue&type=style&index=0&id=80680cb8&lang=css"
script.render = render

export default script